/** Utilities for dealing with Dates */
export class DateUtils {   
    // Adds the number of months to the given date and returns a new date...
    public static addMonthsToDate(date: Date, numMonths: number): Date {
        const d = date.getDate();
        
        const nextDate = new Date(date);
        nextDate.setMonth(nextDate.getMonth() + numMonths);
        if (nextDate.getDate() !== d) {
            nextDate.setDate(0);
        }
        
        return nextDate;
    }
    
    // Returns the # of days between the two dates...
    public static daysBetween(date1: any, date2: any): number {
        return Math.round((date2-date1)/(1000*60*60*24));
    }
    
    // Returns the number of days until the given date...
    public static daysUntil(date: Date): number {
        const today = new Date();
        return DateUtils.daysBetween(today, date);
    }

    // Returns date like: January 1, 2021
    public static toMonthDayYearLongFormat(date: Date): string {
        const options: Intl.DateTimeFormatOptions = { year: "numeric", month: "long", day: "numeric" };
        return date.toLocaleDateString("en-US", options);
    }
}